/**
 * @description Shared interfaces and types for Report Wizard Grid
 */

/**
 * @description Attachment row data structure
 */
export interface AttachmentRow {
    /** How to include the attachment (Link, Attachment, EmbedInReport) */
    IncludeAs: number;
    /** Whether the file can be embedded in the report */
    CanEmbedInReport: boolean;
    /** Whether the attachment is selected for inclusion */
    IsSelected: boolean;
    /** Source type of the attachment */
    SourceType: number;
    /** Source identifier */
    Source: number;
    /** File version ID if applicable */
    FileVersionID: number | null;
    /** Photo ID if applicable */
    PhotoID: string | null;
    /** Date the photo was captured */
    PhotoDateCaptured: string | null;
    /** File ID */
    FileID: string | null;
    /** Name of the file */
    FileName: string;
    /** Description of the attachment */
    Description: string;
    /** File size in megabytes (formatted string) */
    FileSizeInMegabytes: string;
    /** Site capture ID if applicable */
    SiteCaptureId: number;
    /** Name of the capture */
    CaptureName: string | null;
    /** Date/time the capture was made */
    CapturedAt: string;
    /** Maya floor ID if applicable */
    MayaFloorId: string | null;
    /** Maya station ID if applicable */
    MayaStationId: string | null;
    /** Type of attachment */
    Type: number;
    /** File size in bytes */
    FileSize: number;
    /** Collection key */
    CollectionKey: string;
    /** Unique identifier */
    UniqueId: number;
    /** Record ID */
    RecordId: number;
    /** Sort order for drag and drop reordering (optional) */
    SortOrder?: number;
    /** Computed group type for grouping (0 = File, 1 = 360 Captures) - optional as it's added at runtime */
    GroupType?: number;
}

/**
 * @description Include As options enum
 */
export enum IncludeAsTypes {
    Link = 1,
    Attachment = 2,
    EmbedInReport = 3
}

/**
 * @description Attachment types enum
 */
export enum AttachmentTypes {
    FileFile = 0,
    SiteCapturePhoto = 1,
    SiteCaptureVideo = 2
}
